import displayValues from '@/assets/displayValues.json';
import { GuestRatingSquare } from '@/components/guestRatingSquare/GuestRatingSquare';

interface Props {
    ratingKey: string;
    ratingValue: number;
}

export const GuestRatingBar = ({ ratingKey, ratingValue }: Props) => (
    <div className="flex u-mv16">
        <div className="guest-rating-title u-mt2">{displayValues.guestRatingCategories[ratingKey] || ratingKey}</div>
        <div className="guest-rating-bar u-position-relative">
            <div className="u-bg-sardine u-size1of1 u-position-absolute" style={{ borderRadius: '3px', height: '6px', top: '10px' }} />
            <div
                className="u-bg-primary-blue u-position-absolute"
                style={{ borderRadius: '3px', width: `${ratingValue * 10}%`, height: '6px', top: '10px', zIndex: 2 }}
            />
        </div>
        <div className="u-size1of6 flex flex-justify-end">
            <GuestRatingSquare title={displayValues.guestRatingCategories[ratingKey] || ratingKey} guestRating={ratingValue} />
        </div>
    </div>
);
